// extracted by mini-css-extract-plugin
module.exports = {"tabsNav":"EditUser_tabsNav__3CWhm","emptyHeader":"EditUser_emptyHeader__1xg7s","emptyBody":"EditUser_emptyBody__1cLIL","content":"EditUser_content__1dp_y"};